import axios from 'axios';
import React, {Component} from 'react';
import Breadcrumb from '../../../../components/Layout/Breadcrumb';
import ModalComponent from '../../../../components/ModalComponent';
import PaginateComponent from '../../../../components/PaginateComponent';
import { FaUserAlt, FaSearch } from "react-icons/fa";
import {Card, CardBody, CardHeader, Col, Input, Label, Row, Table} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import ListUserComponent from '../../../../components/Admin/users/ListUserComponent';
import { Spinner } from 'react-bootstrap';
import {Link} from "react-router-dom";

class ListUserPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            qtt: 20,
            q: '',
            type: '',
            sort: '',
            isLoading: true,
            listUser: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            userId: 0,
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            userKey: 0,
            alert: {
                error: false,
                message: ''
            },
            isNotification: '',
            textNotification: '',
            type_sort: '',
            firstItem: 0,
            lastItem: 0,
            listGroupUser: {},
            groupUserId: 0,
            actionCredit: 'add',
            text_amount: '',
            amount: 0,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getUser();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getUser = () => {
        this.setState({
            isLoading: true
        });

        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.q + "&type=" + this.state.type
            + "&sort=" + this.state.sort + "&type_sort=" + this.state.type_sort
            + "&groupUserId=" + this.state.groupUserId;
        // console.log(data)
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/user/getUser' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    }),
                    'encryptKey': process.env.REACT_APP_ENCRYPT_KEY,
                    // 'dataInfoAgency': encryptedText
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listUser: ref.data.content.data,
                        listGroupUser: ref.data.content.listGroupUser,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        firstItem: ref.data.content.firstItem,
                        lastItem: ref.data.content.lastItem,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                })
            })
    }

    listUser = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        }
        else {
            if ( this.state.listUser.length ) {
                return (
                    this.state.listUser.map( (user, key) => {
                        return (
                            <ListUserComponent
                                key={user.email}
                                user={user}
                                changeKey={key}
                                checkedUser={ (changeKey, checked) => this.checkedUser(changeKey, checked) }
                                showModal = { (userId, action) => this.showModal(userId, action) }
                            />
                        )
                    })
                )
            }
            else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có khách hàng trong dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

    changeQtt = async (event) => {
        await this.setState({
            qtt: event.target.value
        })
        await this.getUser();
    }

    search = (event) => {
        // console.log(event.target.value)
        this.setState({
            q: event.target.value
        })
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
            this.getUser();
        }
    }

    btnSearch = () => {
        this.getUser();
    }

    changeGroupUser = async (event) => {
        // console.log(event.target.value)
        await this.setState({
            groupUserId: event.target.value
        })
        await this.getUser();
    }

    actionSort = async (type) => {
        if (this.state.sort === '' || this.state.sort === 'ASC') {
            await this.setState({
                type_sort: type,
                sort: 'DESC'
            })
        } else {
            await this.setState({
                type_sort: type,
                sort: 'ASC'
            })
        }

        await this.getUser();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        // let dataAuth = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        // };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.q + "&type=" + this.state.type
            + "&sort=" + this.state.sort + "&type_sort=" + this.state.type_sort
            + "&groupUserId=" + this.state.groupUserId + "&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/user/getUser' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    })
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listUser: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                })
            })
    }

    showModal = (user, action, key) => {
        if ( action === 'delete' ) {
            let titleModal;
            let modalBody;

            titleModal = 'Xóa khách hàng';
            modalBody = this.modalBody(user, action);
            this.setState({
                userId: user.id,
                action: action,
                isModal: true,
                btnConfirmDisabled: false,
                contentModal: {
                    modalBody: modalBody,
                    title: titleModal
                },
                isBtnConfirm: true,
                isSpinner: false,
                userKey: key
            })
        }
        else if (action === 'editCredit') {
            let titleModal;
            let modalBody;

            titleModal = 'Chỉnh sửa số dư tài khoản';
            modalBody = this.modalBody(user, action);

            this.setState({
                userId: user.id,
                action: action,
                isModal: true,
                btnConfirmDisabled: false,
                contentModal: {
                    modalBody: modalBody,
                    title: titleModal
                },
                isBtnConfirm: true,
                isSpinner: false,
                userKey: key
            })
        }
        else if ( action === 'loginAsUser' ) {
            this.loginAsUser(user);
        }
        else if ( action === 'historyPayment' ) {
            this.props.redirectHistoryPayment(user.id);
        }
        else if ( action === 'historyLog' ) {
            this.props.redirectLogActivity(user.id);
        }
    }

    hiddenModal = () => {
        this.setState({
            userId: 0,
            action: '',
            isModal: false,
        })
    }

    modalBody = (user, action) => {
        if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa khách hàng <b className="text-danger">{user.name}</b> này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về khách hàng này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
        else if (action === 'editCredit') {
            return (
                <>
                    <div className="form-group">
                        <Label>Khách hàng</Label>
                        <Input className="form-control" defaultValue={ user.name + " - " + user.email }
                               type="text" disabled={true}
                        />
                    </div>
                    <div className="form-group">
                        <Label>Số dư tài khoản</Label>
                        <Input className="form-control" defaultValue={ user.sdtk }
                               type="text" disabled={true}
                        />
                    </div>
                    <div className="form-group">
                        <Label>Hành động</Label>
                        <select name="actionCredit" id="actionCredit"
                                onChange={ this.changeInput }
                                className="form-control"
                                value={ this.state.actionCredit }
                        >
                            <option value="add">Cộng tiền tài khoản</option>
                            <option value="minus">Trừ tiền tài khoản</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <Label>Số tiền nạp</Label>
                        <input className="form-control" type="text"
                               name="amount" id="amountCredit"
                               onChange={ this.changeInputAmount }
                               placeholder="Số tiền"
                        />
                    </div>
                </>
            )
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]: value
        })
    }

    changeInputAmount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        value = value.replaceAll('.', '');
        value = value.replaceAll(',', '');
        document.getElementById("amountCredit").value = this.addCommas(value);

        this.setState({
            [name]: value,
        })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    confirmModal = () => {
        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
        })
        let actionCredit = "";
        let amount = 0;
        if ( this.state.action === 'editCredit' ) {
            if ( this.state.amount < 1 ) {
                this.setState({
                    contentModal: {
                        modalBody: this.modalBodyConfirm(1, "Số tiền nạp không được nhỏ hơn 1"),
                    },
                })
                return false;
            }
            actionCredit = this.state.actionCredit;
            amount = this.state.amount;
        }

        let form = {
            userId: this.state.userId,
            action: this.state.action,
            actionCredit: actionCredit,
            amount: amount,
        };
        // let dataAuth = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        // };
        axios.put( process.env.REACT_APP_API_URL + '/api/admin/user/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    })
                }
            }
        )
            .then( async (ref) => {
                // console.log(ref.data);
                this.setState({
                    isSpinner: false,
                });
                if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                    this.props.logOut();
                } else {
                    if (this.state.action === 'delete') {
                        if (!ref.data.error) {
                            this.state.listUser.splice(this.state.userKey, 1);
                        }
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error, ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    } else {
                        await this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error, ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                        if (!ref.data.error) {
                            await this.setState({
                                isLoading: true,
                            })
                            await this.getUser();
                        }
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    checkedUser = (changeKey, checked) => {
        let listUser = this.state.listUser;
        listUser.forEach( (user, index) => {
            if ( index === parseInt(changeKey) ) {
                user.checked = checked
            }
        });
        this.setState({
            listUser: listUser
        })
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    changeCheckbox = (event) => {
        let listUser = this.state.listUser;
        listUser.forEach( user => (
            user.checked = event.target.checked
        ));
        this.setState({
            listUser: listUser
        })
    }

    loginAsUser = (user) => {
        this.setState({
            isLoading: true
        });

        // let dataAuth = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        // };

        let form = {
            userId: user.id,
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/admin/user/loginAsUser', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    })
                }
            }
        )
            .then( async (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    let itemUserAdmin = {
                        userId: ref.data.aminId,
                        isAdmin: true
                    }
                    await this.props.updateInfoAdmin(itemUserAdmin);

                    let itemLogin = {
                        token: ref.data.token,
                        is2Fa: true,
                    }
                    await this.props.login(itemLogin);

                    let itemUser = {
                        user: ref.data.user,
                        menu: 'user',
                        sessionRole: 'user',
                        credit: ref.data.credit,
                    }
                    await this.props.saveUser(itemUser);

                    await this.setState({
                        isLoading: false
                    });

                    await this.props.redirect();
                }
                else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error)
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadPage: false,
                    isLoading: false
                })
            })

    }

    render() {
        return (
            <>
                <Breadcrumb title={"Quản lý khách hàng"} page={"Khách hàng"} icon={<FaUserAlt className="breadcrumb-icon" />} />
                <div className="row p-3">
                    <div className="col-md-12">
                        <Link to={"/admin/khach-hang/tao-khach-hang"} className="btn btn-primary">Thêm khách hàng mới</Link>
                    </div>
                </div>
                <div className="row ml-3" style={{ marginTop: 20 }}>
                    <div className="col-md-12">
                        {
                            this.state.error ? (
                                <Alert color="danger">
                                    <div className='text-center'>
                                        { this.state.messageError }
                                    </div>
                                </Alert>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.checkNotification()
                        }
                    </div>
                </div>
                <Card>
                    <CardHeader>
                        <div className="float-left">
                            <div className="input-group input-group-sm">
                                <span className="mr-1">Số lượng</span>
                                <select id="qtt"  onChange={ this.changeQtt } defaultValue={this.state.qtt}>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="60">100</option>
                                </select>
                                <span className="ml-1">hiển thị</span>
                            </div>
                            <div className="text-primary">
                                <b>Hiển thị từ <span className="first-item">{ this.state.firstItem }</span> -
                                    <span className="last-item"> { this.state.lastItem }</span> /
                                    <span className="total-item"> Tổng { this.state.totalPage }</span>
                                </b>
                            </div>
                        </div>
                        <div className="float-right">
                            <div className="input-group">
                                <select name="groupUser" id="groupUser" className="form-control mr-2"
                                        onChange={ this.changeGroupUser }
                                >
                                    <option value="" disabled={true} selected={true}>Chọn nhóm khách hàng</option>
                                    <option value="">Tất cả</option>
                                    <option value="0">Cơ bản</option>
                                    {
                                        this.state.listGroupUser.error === 0 ? (
                                            this.state.listGroupUser.content.map( (groupUser, key) => {
                                                return (
                                                    <option value={groupUser.id} key={groupUser.id + key}>{ groupUser.name }</option>
                                                )
                                            })
                                        ) : (
                                            <></>
                                        )
                                    }
                                </select>
                                <input type="text" name="search" className="form-control"
                                       placeholder="Tìm kiếm tên hoặc email" id="search"
                                       onChange={ this.search }
                                       onKeyPress={ this.submitSearch }
                                />
                                <div className="input-group-append">
                                    <button type="button" className="btn btn-danger" onClick={ () => this.btnSearch() }>
                                        <FaSearch  />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col>
                                <Card className="table-responsive">
                                    <Table className="table-sm table-bordered table-hover rounded table-list">
                                        <thead className={"primary"}>
                                            <tr>
                                                <th
                                                    width={"14%"}
                                                    onClick={ () => this.actionSort('name') }
                                                    className={`
                                                        sorting 
                                                        ${this.state.sort === '' && this.state.type_sort === 'name' ? 'order_by' : ''}
                                                        ${this.state.sort === 'DESC' && this.state.type_sort === 'name' ? 'sorting_desc' : ''}
                                                        ${this.state.sort === 'ASC' && this.state.type_sort === 'name' ? 'sorting_asc' : ''}
                                                    `}
                                                >
                                                    Tên
                                                </th>
                                                <th
                                                    width={"12%"}
                                                    onClick={ () => this.actionSort('email') }
                                                    className={`
                                                        sorting 
                                                        ${this.state.sort === '' && this.state.type_sort === 'email' ? 'order_by' : ''}
                                                        ${this.state.sort === 'DESC' && this.state.type_sort === 'email' ? 'sorting_desc' : ''}
                                                        ${this.state.sort === 'ASC' && this.state.type_sort === 'email' ? 'sorting_asc' : ''}
                                                    `}
                                                >
                                                    Email
                                                </th>
                                                <th  width={"9%"}>Phone</th>
                                                <th width={"9%"}>
                                                    Đại lý
                                                </th>
                                                <th width={"9%"}>
                                                    SDTK
                                                </th>
                                                <th width={"10%"}>
                                                    Tổng nạp
                                                </th>
                                                <th width={"10%"}>
                                                    Tổng tiêu
                                                </th>
                                                <th width={"7%"}>Role</th>
                                                <th
                                                    width={"10%"}
                                                    onClick={ () => this.actionSort('created') }
                                                    className={`
                                                        sorting 
                                                        ${this.state.sort === '' && this.state.type_sort === 'created' ? 'order_by' : ''}
                                                        ${this.state.sort === 'DESC' && this.state.type_sort === 'created' ? 'sorting_desc' : ''}
                                                        ${this.state.sort === 'ASC' && this.state.type_sort === 'created' ? 'sorting_asc' : ''}
                                                    `}
                                                >
                                                    Ngày tạo
                                                </th>
                                                <th width={"10%"}>Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { this.listUser() }
                                        </tbody>
                                        <tfoot className="mt-3">
                                            <tr>
                                                <td colSpan={15}>
                                                    { this.paginate() }
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </Table>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <ModalComponent
                    isModal={ this.state.isModal }
                    content={this.state.contentModal}
                    isBtnConfirm={ this.state.isBtnConfirm }
                    isSpinner={ this.state.isSpinner }
                    btnConfirmDisabled={ this.state.btnConfirmDisabled }
                    hiddenModal={ () => this.hiddenModal() }
                    confirmModal={ () => this.confirmModal() }
                    alert={ this.state.alert }
                />
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminListUser' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateInfoAdmin: (item) => {
            dispatch(({ type : 'updateInfoAdmin', item }))
        },
        login: (item) => {
            dispatch(({ type : 'login', item }))
        },
        saveUser: (item) => {
            dispatch(({ type : 'saveUser', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListUserPage);